<template>
  <div class="page-content">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-10 col-sm-10">
                <h4>Add Notification Blogs</h4>
              </div>
            </div>
          </div>
          <div class="card-body">
            <b-form>
              <!--
                Baris pertama: isi announcement + preview. Konfigurasi CTA sengaja TIDAK di
                sini — dulu semuanya ditumpuk di kolom 4/12 yang lebarnya cuma sepertiga
                kolom kiri, dan kartu opsi poll (gambar + deskripsi + editor) tidak akan
                pernah muat di situ. Sekarang CTA punya sectionnya sendiri selebar penuh.
              -->
              <b-row>
                <b-col cols="8">
                  <b-row>
                    <b-col class="overflow-auto" cols="7">
                      <b-form-group label="Header">
                        <b-form-input v-model="v$.form.header.$model" placeholder="Fill the header" />
                          <b-form-invalid-feedback :state="!v$.form.header.$invalid" v-if="v$.form.header.$error">
                            {{ v$.form.header.$errors[0].$message }}
                          </b-form-invalid-feedback>
                      </b-form-group>

                      <b-form-group label="Sub Header">
                        <b-form-input v-model="v$.form.sub_header.$model" placeholder="Fill the sub header" />
                        <b-form-invalid-feedback :state="!v$.form.sub_header.$invalid" v-if="v$.form.sub_header.$error">
                          {{ v$.form.sub_header.$errors[0].$message }}
                        </b-form-invalid-feedback>
                      </b-form-group>

                      <b-form-group label="Description" class="overflow-auto">
                        <wysiwyg v-model="v$.form.description.$model" placeholder="Fill the description" />
                        <b-form-invalid-feedback :state="!v$.form.description.$invalid" v-if="v$.form.description.$error">
                          {{ v$.form.description.$errors[0].$message }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>

                    <b-col class="overflow-auto" cols="5">
                      <b-form-group label="Published At">
                        <el-date-picker
                          v-model="v$.form.published_at.$model"
                          @change="onChangePublishedAt"
                          :picker-options="date_picker_options"
                          type="datetime"
                          class="w-100"
                          format="yyyy-MM-dd HH:mm"
                          placeholder="Select date and time">
                        </el-date-picker>
                      </b-form-group>
                      <b-form-group label="Published Stop">
                        <el-date-picker
                          :disabled="v$.form.published_at.$model ? false : true"
                          v-model="v$.form.published_stop.$model"
                          :picker-options="date_picker_options"
                          class="w-100"
                          type="datetime"
                          format="yyyy-MM-dd HH:mm"
                          placeholder="Select date and time"
                          @change="validatePublishedStop"
                          >
                        </el-date-picker>
                      </b-form-group>

                      <b-form-group label="Tags">
                        <el-select class="w-100" v-model="v$.form.tags.$model" @change="onChangeTags" placeholder="Select">
                          <el-option
                            v-for="item in tags"
                            :key="item"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>
                        <b-form-invalid-feedback :state="!v$.form.tags.$invalid" v-if="v$.form.tags.$error">
                          {{ v$.form.tags.$errors[0].$message }}
                        </b-form-invalid-feedback>
                      </b-form-group>

                      <b-form-group label="Banner Tone" v-if="form.tags === 'Banner'">
                        <el-select class="w-100" v-model="v$.form.banner_tone.$model" placeholder="Select">
                          <el-option
                            v-for="item in banner_tones"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                        <small class="text-muted">
                          Banner tampil di bawah header dashboard antara Published At dan Published
                          Stop. Kedua tanggal itu WAJIB untuk tipe ini — tanpa Published Stop,
                          banner-nya tidak akan pernah muncul.
                        </small>
                      </b-form-group>

                      <b-form-group label="Upload Attachment">
                      <b-form-file
                          @input="onChangeUploadFile"
                          class="w-100"
                          v-model="v$.form.attachment.$model"
                          accept=".mp4, .pdf"
                          placeholder="Choose an attachment..."
                          browse-text="Browse"
                        ></b-form-file>
                      </b-form-group>
                      <p v-if="!this.loaderStack" class="mb-3">{{ attachmentName }}</p>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="4">
                  <div class="border-left ml-4 p-3">
                    <h3 class="mb-2">{{ form.header }}</h3>
                    <h4 class="mb-2">{{ form.sub_header }}</h4>
                    <div v-if="form.description !== ''" class="preview-content" v-html="form.description"></div>
                  </div>
                </b-col>
              </b-row>

              <hr class="my-4" />

              <!--
                WAP-407 — sumbu terpisah dari Tags. Tags mengatur CARA announcement muncul
                (News diam di bell, Announcement dipaksa jadi popup); CTA mengatur APA yang
                bisa dilakukan user di announcement itu.
              -->
              <b-row>
                <b-col cols="12">
                  <h5 class="mb-3">Call to Action</h5>
                </b-col>
                <b-col cols="4">
                  <b-form-group label="Type">
                    <el-select class="w-100" v-model="v$.form.cta_type.$model" @change="onChangeCtaType" placeholder="Select">
                      <el-option
                        v-for="item in ctaOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <small class="text-muted">{{ ctaHint }}</small>
                  </b-form-group>
                </b-col>

                <b-col cols="8">
                  <template v-if="form.cta_type === 'rsvp'">
                    <b-form-group label="Question (optional)">
                      <b-form-input v-model="v$.form.cta_question.$model" placeholder="Leave empty to use the default question" />
                      <small class="text-muted">
                        Kalau dikosongkan, pertanyaannya ikut bahasa pembaca. Isi kalau label
                        tombolnya kamu tulis sendiri, supaya pertanyaan dan tombol satu bahasa.
                      </small>
                    </b-form-group>
                    <b-row>
                      <b-col cols="6">
                        <b-form-group label="Button Label - Interested">
                          <b-form-input v-model="v$.form.cta_label_primary.$model" placeholder="Default label" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group label="Button Label - Not Interested">
                          <b-form-input v-model="v$.form.cta_label_secondary.$model" placeholder="Default label" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </template>

                  <template v-if="form.cta_type === 'poll'">
                    <b-form-group label="Question">
                      <b-form-input v-model="v$.form.cta_question.$model" placeholder="Contoh: Sesi mana yang paling kamu butuhkan?" />
                      <small class="text-muted">
                        Wajib diisi. Pertanyaan ini yang muncul di atas pilihan — tanpa itu
                        pembaca melihat beberapa kartu tanpa tahu sedang menjawab apa.
                      </small>
                    </b-form-group>
                  </template>

                  <template v-if="form.cta_type === 'url'">
                    <b-row>
                      <b-col cols="7">
                        <b-form-group label="Button Link">
                          <b-form-input v-model="v$.form.cta_url.$model" placeholder="https://..." />
                        </b-form-group>
                      </b-col>
                      <b-col cols="5">
                        <b-form-group label="Button Label">
                          <b-form-input v-model="v$.form.cta_label_primary.$model" placeholder="Default label" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </template>
                </b-col>
              </b-row>

              <!--
                Kartu opsi poll: selebar penuh, satu kartu per baris. Sengaja TIDAK ikut
                carousel seperti di sisi client — waktu menyunting, melihat semua opsi
                sekaligus jauh lebih berguna daripada menggesernya satu-satu.
              -->
              <b-row v-if="form.cta_type === 'poll'">
                <b-col cols="12">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <label class="mb-0">Options</label>
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      :disabled="form.cta_options.length >= poll_max_options"
                      @click="addPollOption"
                    >
                      Add option
                    </b-button>
                  </div>
                  <small class="d-block text-muted mb-3">
                    Minimal {{ poll_min_options }}, maksimal {{ poll_max_options }} pilihan.
                    Pilihan tanpa Label tidak ikut tersimpan. Gambar dan Learn more opsional —
                    tombol Learn more di sisi client hanya muncul kalau salah satunya diisi.
                  </small>

                  <div
                    v-for="(option, index) in form.cta_options"
                    :key="index"
                    class="border rounded p-3 mb-3"
                  >
                    <div class="d-flex align-items-center justify-content-between mb-3">
                      <strong>Pilihan {{ index + 1 }}</strong>
                      <b-button
                        variant="outline-danger"
                        size="sm"
                        :disabled="form.cta_options.length <= poll_min_options"
                        @click="removePollOption(index)"
                      >
                        Remove
                      </b-button>
                    </div>

                    <b-row>
                      <b-col cols="4">
                        <b-form-group label="Image">
                          <img
                            v-if="option.image_url"
                            :src="option.image_url"
                            class="img-fluid rounded mb-2 d-block"
                            style="max-height: 120px"
                          />
                          <b-form-file
                            size="sm"
                            accept="image/*"
                            placeholder="Choose an image..."
                            browse-text="Browse"
                            :disabled="uploading_option === index"
                            @input="(file) => onChangeOptionImage(index, file)"
                          ></b-form-file>
                          <small v-if="uploading_option === index" class="text-muted">Uploading...</small>
                        </b-form-group>
                      </b-col>

                      <b-col cols="8">
                        <b-form-group label="Label">
                          <b-form-input
                            v-model="option.label"
                            :placeholder="`Pilihan ${index + 1}`"
                          />
                        </b-form-group>
                        <b-form-group label="Short description">
                          <b-form-textarea
                            v-model="option.description"
                            rows="2"
                            :maxlength="poll_max_description"
                            placeholder="Satu-dua baris yang tampil di kartu"
                          ></b-form-textarea>
                          <small class="text-muted">
                            {{ (option.description || '').length }}/{{ poll_max_description }}
                          </small>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-button variant="link" size="sm" class="px-0" @click="togglePollContent(index)">
                      {{ editing_content === index ? 'Tutup' : 'Edit' }} Learn more content
                    </b-button>
                    <!--
                      v-if, bukan collapse: vue-wysiwyg berat dan konfigurasinya global, jadi
                      lima editor hidup berbarengan itu yang ingin dihindari. Isinya tetap aman
                      karena yang menyimpan adalah `option.content`, bukan komponennya.
                    -->
                    <div v-if="editing_content === index" class="mt-2">
                      <wysiwyg v-model="option.content" placeholder="Penjelasan lengkap pilihan ini" />
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" class="mt-2 d-flex justify-content-end">
                  <b-button @click="createBlog" variant="primary">Save</b-button>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import moment from 'moment';
// import mime from 'mime';
import blogsNotifApi from '../../api/blogNotif';
import popupErrorMessages from '../../library/popup-error-messages';

export default {
  name: 'Add Notification Blogs',
  metaInfo: {
    title: 'Add Notification Blogs',
  },
  data() {
    return {
      moment,
      loading: {
        create: false,
      },
      form: {
        header: '',
        sub_header: '',
        description: '',
        tags: 'News',
        cta_type: 'none',
        cta_question: '',
        cta_options: [],
        cta_label_primary: '',
        cta_label_secondary: '',
        cta_url: '',
        banner_tone: 'info',
        published_at: '',
        published_stop: '',
        attachment: '',
      },
      // DI MANA notifikasi muncul. 'Banner' = band di bawah header dashboard, window-nya
      // memakai Published At → Published Stop, jadi dua field itu wajib untuk tipe ini.
      tags: ['News', 'Announcement', 'Banner'],
      // APA yang bisa dilakukan pembaca — sumbu terpisah dari Tags.
      cta_types: [
        { value: 'none', label: 'No action' },
        { value: 'rsvp', label: 'RSVP (Interested / Not Interested)' },
        { value: 'poll', label: 'Poll (one question, several choices)' },
        { value: 'url', label: 'Link button' },
      ],
      // Harus cocok dengan POLL_* di backoffice-service-v2: BE menolak/memotong di luar
      // rentang ini, form cuma menghindarkan submit yang pasti gagal.
      poll_min_options: 2,
      poll_max_options: 5,
      poll_max_description: 200,
      // Index opsi yang gambarnya sedang diunggah, dan yang editor Learn more-nya terbuka.
      // Satu editor pada satu waktu supaya tidak ada lima instance wysiwyg hidup bersamaan.
      uploading_option: null,
      editing_content: null,
      banner_tones: [
        { value: 'info', label: 'Info (neutral)' },
        { value: 'live', label: 'Live (attention)' },
      ],
      loader: null,
      loaderStack: 0,
      date_picker_options: {
        disabledDate: (time) => {
          const today = moment().startOf('day');
          const checkDate = moment(time);
          if (checkDate.isBefore(today, 'day')) {
            return true;
          }
          return false;
        },
      },
    };
  },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  validations() {
    return {
      form: {
        header: { required },
        sub_header: { required },
        description: { required },
        tags: { required },
        cta_type: {},
        cta_question: {},
        cta_options: {},
        cta_label_primary: {},
        cta_label_secondary: {},
        cta_url: {},
        banner_tone: {},
        published_at: {},
        published_stop: {},
        attachment: {},
      },
    };
  },
  computed: {
    // Banner adalah band satu baris di bawah header: tidak ada ruang untuk pertanyaan,
    // baik RSVP maupun poll.
    ctaOptions() {
      return this.form.tags === 'Banner'
        ? this.cta_types.filter((v) => !['rsvp', 'poll'].includes(v.value))
        : this.cta_types;
    },
    ctaHint() {
      if (this.form.cta_type === 'rsvp') {
        return 'Menampilkan tombol Interested / Not Interested dan merekam jawabannya.';
      }
      if (this.form.cta_type === 'poll') {
        return 'Menampilkan satu pertanyaan dengan beberapa pilihan, dan merekam pilihan tiap user.';
      }
      if (this.form.cta_type === 'url') {
        return 'Menampilkan satu tombol yang mengarah ke link di bawah.';
      }
      return 'Tanpa tombol tambahan.';
    },
    userProfile() {
      return this.$store.state.auth.userProfile || {};
    },
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace || {};
    },
    checkPermission() {
      const users = this.$store.state.backOffice.userProfile;
      const path = this.$router.currentRoute.fullPath;
      const permission = users.permissions.find((v) => path.includes(v.path));
      return permission.configuration;
    },
    attachmentName() {
      const att = this.form.attachment;
      if (!att) return '';
      if (att instanceof File) {
        return att.name;
      }
      if (typeof att === 'string') {
        try {
          const url = new URL(att);
          return url.pathname.split('/').pop();
        } catch {
          return att;
        }
      }
      return '';
    },
  },
  mounted() {},
  methods: {
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    async createBlog() {
      this.v$.form.$touch();
      if (this.v$.form.$error) return;
      const { form } = this;
      if (form.description !== '') {
        // Remove <video> tags with blob src
        form.description = form.description.replace(
          /<video[^>]*src="blob:[^"]+"[^>]*>[\s\S]*?<\/video>/gi,
          '',
        );
        // Remove <a> tags with blob href
        form.description = form.description.replace(
          /<a[^>]*href="blob:[^"]+"[^>]*>[\s\S]*?<\/a>/gi,
          '',
        );
      }
      if (form.attachment !== '' || form.attachment) {
        if (form.attachment instanceof File) {
          const mbSize = 15;
          // const fileExt = mime.getExtension(form.attachment.type);
          // if (fileExt === 'mp4') {
          //   mbSize = 16;
          // } else if (fileExt === 'pdf') {
          //   mbSize = 100;
          // }
          const maxSize = mbSize * 1024 * 1024;
          if (form.attachment.size > maxSize) {
            form.attachment = '';
            this.form.attachment = '';
            this.$message.error(`Attachment size maximum ${mbSize} MB`);
            return;
          }
          const base64File = await this.toBase64(form.attachment);
          form.attachment = base64File;
        }
      }
      this.showLoader();
      const response = await blogsNotifApi.create(form);
      this.hideLoader();
      await popupErrorMessages(response).then(() => {
        this.$message({
          message: this.$t('blog_notification.success.create'),
          type: 'success',
        });
        this.form = {
          header: '',
          sub_header: '',
          description: '',
          tags: '',
          cta_type: 'none',
          cta_question: '',
          cta_options: [],
          cta_label_primary: '',
          cta_label_secondary: '',
          cta_url: '',
          banner_tone: 'info',
          published_at: '',
          published_stop: '',
          attachment: '',
        };
        this.$router.push({
          name: 'Notification Blogs',
        });
      });
    },
    // Bersihkan field yang tidak lagi relevan, supaya nilai lama tidak diam-diam ikut
    // tersimpan dan muncul lagi kalau CTA-nya dinyalakan ulang.
    onChangeCtaType(value) {
      if (value !== 'rsvp') this.form.cta_label_secondary = '';
      if (value !== 'url') this.form.cta_url = '';
      if (value === 'none') this.form.cta_label_primary = '';
      if (value !== 'rsvp' && value !== 'poll') this.form.cta_question = '';
      this.form.cta_options = value === 'poll' ? this.ensurePollOptions() : [];
    },
    // Poll selalu dibuka dengan baris kosong sebanyak minimum, jadi tidak ada keadaan di mana
    // tipe-nya sudah poll tapi tidak ada satu pun kolom untuk diisi.
    ensurePollOptions() {
      const options = Array.isArray(this.form.cta_options) ? this.form.cta_options.slice() : [];
      while (options.length < this.poll_min_options) options.push(this.emptyPollOption());
      return options;
    },
    // Semua key hadir sejak awal: Vue 2 tidak bisa melacak properti yang ditambahkan
    // belakangan, jadi opsi tanpa `image_url` awal tidak akan pernah merender preview-nya.
    emptyPollOption() {
      return {
        key: '', label: '', description: '', image_url: '', content: '',
      };
    },
    togglePollContent(index) {
      this.editing_content = this.editing_content === index ? null : index;
    },
    /**
     * Gambar diunggah begitu dipilih dan yang disimpan ke form cuma URL-nya.
     *
     * Bukan base64 di payload create/edit: lima gambar dalam satu submit jadi payload
     * beberapa MB, dan kegagalannya baru ketahuan setelah menekan Save.
     */
    async onChangeOptionImage(index, file) {
      if (!file) return;
      this.uploading_option = index;
      try {
        const response = await blogsNotifApi.uploadAttachment(file);
        await popupErrorMessages(response);
        const url = response.data?.secure_url;
        if (url) this.form.cta_options[index].image_url = url;
      } finally {
        this.uploading_option = null;
      }
    },
    // `key` dibiarkan kosong: BE yang men-generate-nya sekali, dan sesudah itu key-nya tidak
    // berubah walau labelnya disunting. Itu yang menjaga jawaban lama tetap menunjuk pilihan
    // yang sama — key posisional akan bergeser artinya begitu urutannya diubah.
    addPollOption() {
      if (this.form.cta_options.length >= this.poll_max_options) return;
      this.form.cta_options.push(this.emptyPollOption());
    },
    removePollOption(index) {
      if (this.form.cta_options.length <= this.poll_min_options) return;
      this.form.cta_options.splice(index, 1);
      // Editor yang terbuka menunjuk index, dan index bergeser setelah splice — tanpa ini
      // yang terbuka jadi opsi yang salah.
      this.editing_content = null;
    },
    // Banner tidak menawarkan pertanyaan. Kalau tag diganti ke Banner sementara CTA-nya masih
    // rsvp/poll, turunkan ke none supaya form tidak mengirim kombinasi yang ditolak BE.
    onChangeTags(value) {
      if (value === 'Banner' && ['rsvp', 'poll'].includes(this.form.cta_type)) {
        this.form.cta_type = 'none';
        this.onChangeCtaType('none');
      }
    },
    onChangeUploadFile(file) {
      if (!file) return;
      const fileUrl = URL.createObjectURL(file);
      const isVideo = file.type.includes('video');
      const isPdf = file.type === 'application/pdf';
      // 🧹 Remove ALL existing video + PDF tags before adding new
      this.form.description = this.form.description
        .replace(/<video[\s\S]*?<\/video>/gi, '')
        .replace(/<a[^>]*href="[^"]*"[^>]*>[^<]*<\/a>/gi, '');
      if (isVideo) {
        const videoTag = `<video src="${fileUrl}" controls class="mt-3 w-100" style="max-height: 300px;"></video><br />`;
        this.form.description += videoTag;
      }
      if (isPdf) {
        const pdfTag = `<a href="${fileUrl}" target="_blank" class="mt-3 d-block text-primary">View PDF</a><br />`;
        this.form.description += pdfTag;
      }
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    validatePublishedStop(value) {
      const publishedAt = this.v$.form.published_at.$model;
      const publishedStop = value;
      if (publishedAt && publishedStop) {
        const start = moment(publishedAt, 'YYYY-MM-DD HH:mm').seconds(0).milliseconds(0);
        const stop = moment(publishedStop, 'YYYY-MM-DD HH:mm').seconds(0).milliseconds(0);
        if (start > stop) {
          this.$message.error('Published Stop must be more than Published At');
          this.v$.form.published_stop.$model = null;
        }
      }
    },
    onChangePublishedAt(value) {
      if (!value) {
        this.form.published_at = null;
        this.form.published_stop = null;
        return;
      }
      const start = moment(value, 'YYYY-MM-DD HH:mm').seconds(0).milliseconds(0);
      const now = moment().seconds(0).milliseconds(0);
      if (start.isBefore(now)) {
        this.$message.error('Published At must be more than or equal to current time');
        this.form.published_at = null;
        return;
      }
      this.form.published_at = value;
    },
  },
};
</script>
<style>
  .preview-content img {
    max-width: 100%;
    height: auto;
    max-height: 200px;
    object-fit: contain;
    display: block;
  }
  .preview-content table {
    width: 100%;
    border-collapse: collapse;
  }
  .preview-content table td,
  .preview-content table th {
    border: 1px solid #ccc;
    padding: 8px;
    color: #000;
    font-family: "Open Sans", Arial, sans-serif;
    text-align: left;
  }
  /* .preview-content {
    max-height: 400px;
    overflow-y: auto;
  } */
</style>
